import type { CSSProperties } from 'react'

import cn from 'clsx'
import { HyperLink } from '@/components/hyper-link/hyper-link'
import type { HyperLinkProps } from '@/components/hyper-link/hyper-link'

import css from './LeftBarButton.module.css'

export interface LeftBarButtonProps extends Omit<HyperLinkProps, 'bold' | 'size'> {
    children: React.ReactNode
    className?: string
    indicatorColor?: string
}

interface LeftBarButtonCustomProps extends CSSProperties {
    '--indicator-color': string
}

export function LeftBarButton({
    className,
    children,
    indicatorColor = 'var(--red-500)',
    ...rest
}: LeftBarButtonProps) {
    const customProps: LeftBarButtonCustomProps = {
        '--indicator-color': indicatorColor,
    }

    return (
        <HyperLink className={cn(css.leftBarButton, className)} style={customProps} {...rest}>
            <div className={css.content}>{children}</div>
        </HyperLink>
    )
}
